// Conversion-focused homepage with clear positioning
import React from 'react';
import { Navigation } from './navigation';
import { HeroSection } from './hero-section';
import { DualOfferSection } from './dual-offer-section';
import { TwelveWeekRoadmap } from './twelve-week-roadmap';
import { TypicalProjectSection } from './typical-project-section';
import { WhoWeWorkWith } from './who-we-work-with';
import { PricingSection } from './pricing-section';
import { AppSuccessStories } from './app-success-stories';
import { AboutSection } from './about-section';
import { CommonQuestions } from './common-questions';
import { LetsTalkCTA } from './lets-talk-cta';
import { ContactFormSection } from './contact-form-section';
import { Footer } from './footer';

export const Homepage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-6 focus:py-3 focus:bg-primary focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>
      
      <Navigation />
      <main id="main-content">
        <HeroSection />
        <DualOfferSection />
        <TwelveWeekRoadmap />
        <TypicalProjectSection />
        <WhoWeWorkWith />
        <AppSuccessStories />
        <PricingSection />
        <AboutSection />
        <CommonQuestions />
        <LetsTalkCTA />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};
